import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Lead_New } from 'app/shared/models/leads_new.model';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddComponent implements OnInit,OnDestroy  {
  @ViewChild("search")
  public searchElementRef: ElementRef;

  contactList = []
  contactSelect: any = null
  sourceList = [];
  typeList = []
  type_idList = []
  platformList = []
  lead_statusList = []
  lead_stageList = []
  nextactionList = []

  isEdit = false;
  source_tagcat_id = '63e3993c2052e0098e18df88'
  type_tagcat_id = '63e39cf92052e0098e18e003'
  lead_status_tagcat_id = '63e391812052e0098e18de76'
  lead_stage_tagcat_id = '63e397c12052e0098e18df3d'
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'

  socialmedia_tagcat_id = '63e39e5b2052e0098e18e02a'
  type_id_tagcat_id = ''

  source: any = null
  type: any = null
  platform: any = null
  lead_status: any = null
  lead_stage: any = null
  nextaction: any = null
  type_id: any = null
  title_lead: any
  socailmediaList = []
  catId = '6319d5025ab9e462a96cfbba'
  skillId = '6319d3595ab9e462a96cfb06'
  currentDate:string
  leadModel = {
    name: '',
    email: '',
    phone: '',
    address: null,
    landmark:{ type:'Point',address:'',coordinates:[]},
    location: '',
    socialmedia: null,
    college_id: null,
    coursecatinterest_id: null,
    skillsinterst_id: [],
    qualification: '',
    title: '',
    source: '63e399762052e0098e18df98',
    platform: '',
    last_activedate: '',
    lastresponse: '',
    ip: '',
    next_action: '63e39be02052e0098e18dfde',
    notes:'',
  }
  
  latitude: number = null;
  longitude: number = null;
  zoom: number;
  geoCoder;
  selectedCategory = null;
  categoryList = [];
  tagsList = [];
  selectedTag: string[] = [];
  collegeList = [];
  businessTypeCollege_Id = '6325cdefbc4b543c7a2429a4'
  isEditContact: boolean = false
  isEditTraining: boolean = false
  currentUrl: any
  leadId:any
  selectedSkill: string[] = [];
  phoneControl = new FormControl()
  isPhoneExists :any
  constructor(
    public toastr: ToastrService,
    public apiService: ApiService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private activerouter: ActivatedRoute,
    ) {
      // this.locationAutoComplete();
    this.currentUrl = this.activerouter.snapshot.routeConfig.path
    this.activerouter.paramMap.subscribe(params => { 
      this.leadId = params.get('id');  
    }) 
    if(this.currentUrl ==='edit/:id'){
      this.getTypeTags()
      this.getNextActionTags()
      this.getContactList()
      this.getScoialMediaTags() 
      this.getLeadsBy_Id();
    }
    if(this.currentUrl ==='add'){
      this.getTypeTags()
      this.getNextActionTags()
      this.getContactList()
      this.getScoialMediaTags() 
    }
    
  }
   ValidateEmail(mail){
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

   if (emailRegex.test(mail))
    {
      return (false)
    }
      return (true)
  }
 allLetter(inputtxt){
   var letters = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
   if(inputtxt.value!==null&&inputtxt.value.match(letters))
     {
      return true;
     }
   else
     {
     return false;
     }
  }
  ngOnInit() {
    if(this.currentUrl ==='add'){
      this.currentDate = new Date().toISOString().substring(0, 10);
      this.leadModel.last_activedate=this.currentDate
       this.getTagByCategory()
       this.getSkillTagByCategory()
       this.getAllCollege()
       this.getSource()
       
       this.phoneControl.valueChanges.subscribe(value => {
        if(value && value.length === 10){
          this.apiService.isTrainingLeadsByPhoneExists(value).subscribe((res:any)=>{
            if(res?.statusCode === 200 && res?.data === true){
              this.isPhoneExists = "Phone number already exists!"
            }
            else this.isPhoneExists = ""
          })
        }
      });
    }
    if(this.currentUrl ==='edit/:id'){
       this.getTagByCategory()
       this.getSkillTagByCategory()
       this.getAllCollege()
       this.getSource()
    }
  
  }
  
  getLeadsBy_Id(){
     this.apiService.getLeadsById(this.leadId).subscribe((res: any) => {
    // --- 1st Step -------
    this.leadModel.name = res?.data[0].contact_id.name
    this.leadModel.email = res?.data[0].contact_id.email
    this.leadModel.phone = res?.data[0].contact_id.phone
    this.leadModel.email = res?.data[0].contact_id.email
    if(res?.data[0].contact_id.socialmedia){
      this.leadModel.socialmedia = res?.data[0].contact_id.socialmedia._id
    }
  if(res?.data[0].contact_id.landmark){
    this.leadModel.landmark = res?.data[0].contact_id.landmark
  }
    
    this.leadModel.location = res?.data[0].contact_id.location
    // --- 2nd Step -------
    this.leadModel.title = res?.data[0].title
    this.leadModel.lastresponse = res?.data[0].lastresponse
    if(res?.data[0].source._id){
      this.leadModel.source = res?.data[0].source._id
    }
    this.leadModel.last_activedate = res?.data[0].last_activedate
    if(res?.data[0].next_action._id){
      this.leadModel.next_action = res?.data[0].next_action._id
    }
    // this.leadModel.next_action = this.lead?.next_action?._id
    this.leadModel.notes = res?.data[0].notes
    // --- 3rd Step -------
    if(res?.data[0]?.type_id?.college_id?._id){
      this.leadModel.college_id = res?.data[0]?.type_id?.college_id?._id
    }
    if(res?.data[0]?.type_id?.coursecatinterest_id?._id){
      this.leadModel.coursecatinterest_id = res?.data[0]?.type_id?.coursecatinterest_id?._id
    }
    if(res?.data[0]?.type_id?.qualification){
      this.leadModel.qualification = res?.data[0]?.type_id?.qualification   
    }
    if(res?.data[0]?.type_id?.skillsinterst_id){
      this.leadModel.skillsinterst_id = res?.data[0]?.type_id?.skillsinterst_id
      this.selectedSkill = res?.data[0]?.type_id?.skillsinterst_id.map((item)=> item._id)
      this.leadModel.skillsinterst_id=this.selectedSkill
    }
    
    // this.leadModel.skillsinterst_id=this.lead?.type_id?.skillsinterst_id.map((item)=> item._id)
    //  console.log('skillsinterst_id=>>',this.leadModel.skillsinterst_id)
      // this.getAddress()

    })
  }
  getSource() {
     this.apiService.getTagByTagCatgoryId(this.source_tagcat_id).subscribe((res: any) => {
      this.sourceList = res.data
    })
  }
  getSourceId(event: any) {
    this.leadModel.source
  }
  getAllCollege() {
     this.apiService.getBusinessListBytype(this.businessTypeCollege_Id, '').subscribe((res: any) => {
      this.collegeList = res.data
    })
  }
  getCollegeId(event: any) {
    this.leadModel.college_id
  }
  getTagByCategory() {
     this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res: any) => {
      this.categoryList = res.data
    })
  }
  getCategoryId(event: any) {
    this.leadModel.coursecatinterest_id
  }
  getSkillTagByCategory() {
     this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.tagsList = res.data
    })
  }
  getTagsId(event: any) {
    this.selectedSkill 
    if(this.leadId){
      this.leadModel.skillsinterst_id=this.selectedSkill
    }
  }
  getScoialMediaTags() {
     this.apiService.getTagByTagCatgoryId(this.socialmedia_tagcat_id).subscribe((res: any) => {
      this.socailmediaList = res.data
    })
  }
  getChangeSocialMedia(event) {
    this.leadModel.socialmedia
    console.log('=>>', this.leadModel.socialmedia)
  }
  getContactList() {
     this.apiService.getContactList(1, 100).subscribe((res: any) => {
      this.contactList = res.data.items
    })
  }
  getChangeContact(event) {
    this.leadModel.title = event.name
  }
  getTypeTags() {
     this.apiService.getTagByTagCatgoryId(this.type_tagcat_id).subscribe((res: any) => {
      this.typeList = res.data
    })
  }
  getChangeType(event) {
    this.type
  }

  getNextActionTags() {
     this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res.data
    })
  }
  getChangeNextAction(event) {
    this.nextaction
  }
  
  getChangeType_id(event) {
    this.type_id
  }

  leadSubmit() {
    let body = {
      // contact
      name:this.leadModel.name,
      email:this.ValidateEmail(this.leadModel.email)?'':this.leadModel.email,
      phone:this.leadModel.phone,
      location:this.leadModel.location,
      socialmedia:this.leadModel.socialmedia?this.leadModel.socialmedia:'',
      address:this.leadModel.address,
      lat:this.latitude,
      lng:this.longitude,
// training lead 
      college_id:this.leadModel.college_id,
      coursecatinterest_id:this.leadModel.coursecatinterest_id?this.leadModel.coursecatinterest_id:'',
      skillsinterst_id:this.selectedSkill?this.selectedSkill:'',
      qualification:this.leadModel.qualification,
      // lead
      source: this.leadModel.source?this.leadModel.source:'',
      title: this.leadModel.title,
      next_action: this.leadModel.next_action?this.leadModel.next_action:'',
      last_activedate: this.leadModel.last_activedate,
      lastresponse: this.leadModel.lastresponse,
      notes:this.leadModel.notes,
      type: '63e39db72052e0098e18e00e', // training_lead Tag
      lead_status: '63e396de2052e0098e18deec', // open Tag
      lead_stage: '63e391a22052e0098e18de7f', // prospect Tag
  }
     
      if(this.leadId){
         this.apiService.updateLeads(this.leadId,this.leadModel).subscribe((res:any)=>{
         
          if (res?.statusCode === 200) {
            this.toastr.success("Updated Successfully")
            // this.route.navigate(['/leads/training-leads'])
            window.history.back()
          }
          else { this.toastr.error(res.error) }
        })
      }
      if(!this.leadId){
         this.apiService.createLeads(body).subscribe((res: any) => {
          if (res?.statusCode === 200) {
            this.toastr.success("Created Successfully")
            // this.route.navigate(['/leads/training-leads'])
            window.history.back()

          }
          else { this.toastr.error(res.error) }
        })
      }
  }
 
  back() {
    // this.route.navigate(['/leads/training-leads'])
    window.history.back()

  }
  // locationAutoComplete() {
  //   this.mapsAPILoader.load().then(() => {
  //     this.geoCoder = new google.maps.Geocoder;

  //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
  //     autocomplete.addListener('place_changed', () => {
  //       this.ngZone.run(() => {
  //         let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  //         this.leadModel.address = place.formatted_address;
  //         // verify result
  //         if (place.geometry === undefined || place.geometry === null) {
  //           return;
  //         }

  //         // set latitude, longitude and zoom
  //         this.latitude = place.geometry.location.lat();
  //         this.longitude = place.geometry.location.lng();
  //         this.zoom = 12;
  //         if(this.leadId){
  //           this.leadModel.landmark.address=place.formatted_address
  //           this.leadModel.landmark.coordinates=[this.latitude,this.longitude]
  //         }
  //       });
  //     });
  //   });
  // }
  // ngAfterViewInit() {
  //   this.locationAutoComplete();
  // }
  
  ngOnDestroy(){
    this.leadId = null
    this.currentUrl = null
    this.leadModel = {
      name: '',
      email: '',
      phone: '',
      address: null,
      landmark: { type: 'Point', address: '', coordinates: [] },
      location: '',
      socialmedia: null,
      college_id: null,
      coursecatinterest_id: null,
      skillsinterst_id: [],
      qualification: '',
      title: '',
      source: '63e399762052e0098e18df98',
      platform: '',
      last_activedate: '',
      lastresponse: '',
      ip: '',
      next_action: '63e39be02052e0098e18dfde',
      notes: '',
    };
  }
}
